import { useQuery } from "@tanstack/react-query"
import { students } from "@shared/api/services"

export const useMyStudents = (params, enabled = true) => {
	return useQuery({
			queryKey: ['my-students', params],
			queryFn: () => students.getMyStudents(params),
			select: (data) => data.data,
			enabled: enabled && !!localStorage?.getItem("token")
	})
}